<div class="price-chart-wrapper">
  <div echarts [options]="chartOptions()" [theme]="graphLightTheme" class="echart-container"></div>
  <div class="chart-legend-description">
    <span class="legend-line legend-line--low"></span> Strømsats bund: {{ formattedLowLimit() }}
    <span class="legend-line legend-line--high"></span> Strømsats loft: {{ formattedHighLimit() }}
  </div>
</div>
